import unidad_medida_model from './unidad_medida_model';

export default {
  Codigo: null,
  Descripcion: null,
  CodigoEquivalente: null,
  Activo: true,
  CodigoUnidadMedida: null,
  CodigoUnidadTiempo: null,
  // COTI-502: Determinar label para polimero
  LabelTotalPolimeros: null,
  LabelTiempoPolimero: null,
  LabelMermaPolimero: null,
  UnidadMedida: { ...unidad_medida_model },
  UnidadTiempo: { ...unidad_medida_model },
};
